export const nl = {
	project_name: 'Broederlijk Delen',
	cards: {
		event: {
			linklabel: 'Bekijk event'
		},
		page: {
			linklabel: 'Bekijk pagina'
		},
		project: {
			linklabel: 'Bekijk project'
		}
	},
	list: {
		view: 'Bekijk pagina'
	},
	form: {
		file: {
			delete: 'Verwijder',
			invalid_type: 'Ongeldig bestandstype',
			too_large:
				'Bestand is te groot. De maximale bestandsgrootte is ingesteld op'
		},
		back: 'Terug',
		submit: 'Verstuur'
	},
	newsletter: {
		title: 'Nieuwsbrief',
		submitted: 'Bedankt om je in te schrijven op de nieuwsbrief'
	},
	newsletterpage: {
		fname: 'Voornaam (*)',
		lname: 'Achternaam (*)',
		email: 'E-mailadres (*)',
		gender: 'Genderidentiteit',
		gender_male: 'm',
		gender_female: 'v',
		gender_unknown: 'x',
		phone: 'Telefoonnummer',
		mobile: 'Gsmnummer',
		birthdate: 'Geboortedatum',
		agreement_privacy_policy: 'Ik ga akkoord met de',
		refine_title: 'Verfijn je nieuwsbriefselectie',
		region_title: 'Regio',
		regio_antwerpen: 'Regionaal nieuws Antwerpen',
		regio_oost_vlaanderen: 'Regionaal nieuws Oost-Vlaanderen',
		regio_limburg: 'Regionaal nieuws Limburg',
		regio_vlaams_brabant:
			'Regionaal nieuws Vlaams-Brabant / Brussel / Mechelen',
		regio_west_vlaanderen: 'Regionaal nieuws West-Vlaanderen',
		interests_title: 'Interesses',
		interesses_nieuwsbrief: 'Algemene nieuwsbrief',
		interesses_meegedeeld: 'MEEgedeeld',
		interesses_sportieve_evenementen: 'Sportieve evenementen',
		interesses_evenementen_bd: 'Evenementen van Broederlijk Delen',
		interesses_lager_onderwijs: 'Lager onderwijs',
		interesses_secundair_onderwijs: 'Secundair onderwijs',
		interesses_jongereninfo: 'Jongereninfo',
		interesses_lezingen_debatten: 'Lezingen en debatten',
		submit: 'Ik schrijf me in',
		thanks_title: 'Bedankt!'
	},
	collaborator: {
		and: 'en'
	},
	search: {
		search: 'Zoeken',
		submit: 'Doorzoek de website',
		empty: 'Geef een zoekopdracht in.',
		results: {
			loading: 'Laden',
			empty: 'Geen resultaten gevonden voor de huidige zoekopdracht.'
		}
	},
	footer: {
		ef: {
			link: 'https://www.re-ef.be/'
		},
		efqm: {
			link: 'https://efqm.org/'
		},
		donorinfo: {
			link: 'https://donorinfo.be/'
		}
	},
	error404: {
		title: 'Pagina niet gevonden',
		text:
			'De pagina die je probeert te bereiken is niet beschikbaar of is onlangs verwijderd.',
		btnlabel: 'Ga naar startpagina'
	},
	cookies: {
		banner: {
			text:
				'Deze website maakt gebruik van cookies om de surfervaring aangenamer te maken en om je persoonlijke instellingen en voorkeuren bij te houden.',
			settings: 'Cookie-instellingen',
			accept: 'Alle cookies accepteren',
			decline: 'Optionele cookies weigeren'
		},
		settings: {
			title: 'Cookie-instellingen',
			text:
				'Je kunt alle cookies in één keer accepteren of je voorkeuren aanpassen in de cookie-instellingen.',
			save: 'Opslaan',
			accept: 'Alle cookies accepteren',
			decline: 'Optionele cookies weigeren'
		},
		used: 'Gebruikte cookies',
		table: {
			name: 'Naam',
			purpose: 'Doel',
			domain: 'Domein/host',
			duration: 'Duur'
		},
		duration: {
			persistent: 'Permanent',
			session: 'Sessie',
			day: 'dag',
			days: 'dagen',
			month: 'maand',
			months: 'maanden',
			year: 'jaar'
		}
	},
	cta: {
		donation: {
			btn_label: 'Doe een gift'
		},
		magazine: {
			btn_label: 'Doe een gift'
		},
		support: {
			btn_label: 'Steun Broederlijk Delen'
		}
	},
	teams: {
		search: 'Doorzoek de teams',
		search_label: 'Zoek de deelnemer die je wil steunen:',
		search_empty: 'Er zijn geen teams gevonden voor deze zoekwoorden',
		card: {
			to_team_detail: 'Naar actiepagina',
			support_team: 'Steun dit team',
			from: 'Uit',
			with: 'Met',
			load_more: 'Laad meer'
		},
		overview: {
			info: {
				was_gathered_by: `werd ingezameld dankzij de {{numberOfTeams}} deelnemende teams`,
				was_gathered_by_single: `werd ingezameld dankzij het deelnemende team`,
				share: 'Deel actie'
			}
		},
		detail: {
			outcity: ' uit ',
			members: 'Bestaat uit volgende deelnemers:',
			support: {
				title: 'Je kan ook steunen via overschrijving:',
				iban_label: 'Op rekeningnummer',
				ogm_label: 'Met deze mededeling',
				form: {
					options_label: 'Kies een bedrag',
					custom_label: 'Ander bedrag',
					submit: 'Steun dit team'
				}
			},
			donations: {
				title: 'Laatste donaties',
				item: {
					outcity: ` uit {{city}}`,
					somebody: 'Iemand',
					subtitle: 'euro'
				}
			},
			collected: {
				title: 'Donaties aan jouw team',
				text: `<p>Jullie verzamelden al <b>€{{price}}</b> !<br>Download hier een up-to-date overzicht van al jullie donaties.</p>`,
				btnlabel: 'Download overzicht'
			}
		}
	},
	impact: {
		projects: {
			worldmap: {
				select_all: "Selecteer alle thema's",
				clear_all: "Verwijder alle thema's"
			},
			regions: {
				select_all: "Selecteer alle regio's"
			},
			country_fiche: {
				focus_themes: 'Dit project focust op de volgende thema’s:'
			},
			filter_empty: 'Er zijn geen resultaten beschikbaar voor deze filters.',
			related: {title: 'Verwante projecten'}
		}
	},
	overview: {
		load_more: 'Laad meer'
	},
	agenda: {
		title: 'Aankomende events',
		filters: {
			title: 'Filters',
			location: {
				label: 'Zoek op gemeente of postcode',
				placeholder: 'Gemeente, postcode, ...'
			},
			radius: 'Straal',
			keyword: {
				label: 'Zoek op trefwoord',
				placeholder: 'vb. Straatfeest'
			},
			periode: 'Zoek op datum of periode',
			periode_detail: 'Event vindt plaats',
			and: 'en',
			submit: 'Filter',
			reset: 'Reset',
			errors: {
				no_radius_exception: 'Zet een straal om op locatie te zoeken',
				no_location_exception: 'Selecteed een locatie om op locatie te zoeken',
				no_results:
					'We kunnen geen resultaten vinden die onder deze filter(s) vallen'
			},
			on: 'op',
			between: 'tussen'
		},
		information: {
			title: 'Praktische informatie',
			from: 'van',
			until: 'tot en met',
			on: 'op',
			at: 'om'
		}
	},
	news: {
		title: 'Nieuws en persberichten',
		readmore: 'Lees meer',
		publishedOn: 'Gepubliceerd op'
	},
	events: {
		participants: {
			title: 'Nieuwste deelnemers',
			linklabel: 'Naar pagina',
			total: `De {{numberOfTeams}} deelnemende teams verzamelden`,
			totalSingle: `Het deelnemende team verzamelde`,
			all: 'Toon alle deelnemende teams'
		},
		route: {
			title: 'Route',
			walking: 'wandelen',
			biking: 'fietsen'
		},
		related: {
			title: 'Verwante events',
			benefit: 'Ten voordele van',
			all_events: 'Alle events'
		},
		info_share: {
			action_starts: 'Actie begint binnen',
			action_endures: 'Actie loopt nog'
		},
		register: {
			step: 'Stap',
			next_step: 'Volgende stap',
			teamowner: 'Teamverantwoordelijke',
			teammember: 'Teamlid',
			remove_teammember: 'Verwijder dit teamlid',
			add_teammember: 'Voeg nog een teamlid toe',
			subscribe_individual: 'Schrijf je in',
			subscribe_team: 'Schrijf je team in'
		}
	},
	personblock: {
		about: 'Over'
	},
	webshop: {
		filter: {
			load_more: 'Laad meer',
			load_more_products: 'Laad meer bestelbare producten',
			load_more_downloads: 'Laad meer downloads',
			label: 'Ik wil',
			reset: 'Reset',
			empty: 'Er zijn geen resultaten beschikaar',
			no_products:
				'We kunnen geen producten vinden die onder deze filter(s) vallen.',
			no_downloads:
				'We kunnen geen downloads vinden die onder deze filter(s) vallen.'
		},
		header: {
			cart: {
				items_in_cart: 'item(s) in winkelwagen',
				empty: 'Winkelwagen is leeg'
			}
		},
		products: {
			card: {
				from: 'vanaf',
				pieces: 'st.',
				free: 'Gratis',
				add: 'Voeg toe',
				notifiy: 'Verwittig me',
				remove: 'Verwijder',
				featured: 'Aanbevolen',
				last_pieces: 'Laatste stuks',
				temporarily_unavailable: 'Tijdelijk niet beschikbaar',
				sold_out: 'Uitverkocht',
				coming_soon: 'Binnenkort beschikbaar',
				added: 'Toegevoegd'
			},
			notify: {
				info: 'Stuur een mail als dit product weer voorradig is.',
				newsletter: 'Schrijf me ook in op de nieuwsbrief.',
				submit: 'Hou me op de hoogte',
				submitted:
					'Bedankt! Je krijgt een notificatie wanneer dit product terug in voorraad is.'
			},
			related: 'Gerelateerde producten'
		},
		cart: {
			title: 'Winkelwagen',
			from: 'vanaf',
			pieces: 'st.',
			remove: 'Verwijder uit winkelwagen',
			add: 'Voeg toe',
			edit: 'Pas aan',
			edited: 'Is aangepast',
			added: 'Is toegevoegd',
			quantity_discount: 'Hoeveelheidskorting',
			free: 'Gratis',
			empty: 'Je winkelwagen bevat nog geen producten.',
			total: 'Totaal bedrag',
			abandoned: {
				title: 'Je staat op het punt je winkelwagen te verliezen.',
				text: `Er zitten momenteel nog {{countProducts}} items in jouw winkelwagen. Ben je zeker dat je deze pagina wil verlaten?`,
				btnclose: 'Verder winkelen',
				btnback: 'Terug naar winkelwagen'
			},
			order: 'Bestel'
		}
	},
	campagne: {
		open: 'Open',
		close: 'Sluiten',
		share: 'Deel op',
		languages: 'Talen',
		hero: {
			help: 'Hulp nodig?'
		},
		footer: {
			copyright: '2020 Broederlijk Delen, alle rechten voorbehouden',
			do_action: 'Doe een actie',
			register_action: 'Registreer actie'
		},
		action: {
			watch: 'Bekijk actie',
			share: 'Deel actie',
			watch_page: 'Bekijk je actie-pagina',
			promotion_title: 'Promoot je actie',
			promotion_share: 'Deel deze actie',
			poster: 'Poster A4',
			need: 'Benodigdheden',
			download: 'Download',
			order: 'Bestel je materiaal',
			share_online: 'Online delen',
			header: 'Omslagfoto voor Facebook',
			shareimage: 'Afbeelding voor social media',
			copied: 'Tekst gekopieerd!'
		},
		actions: {
			title: 'Zij gingen je al voor...',
			loadmore: 'Meer acties laden',
			no_results: 'Er zijn geen resultaten beschikbaar voor deze filter',
			clearfilters: 'Filters verwijderen'
		},
		inspiration: {
			practical: 'Praktische informatie'
		},
		inspirations: {
			checkout: 'Bekijk inspiratie',
			select: 'Selecteer'
		},
		info: {
			moreinfo: 'Meer informatie',
			practical: 'Praktische informatie',
			on: 'op',
			from: 'van',
			until: 'tot',
			at: 'om',
			between: 'tussen',
			and: 'en',
			box: 'bus',
			not_public: 'Dit evenement is niet openbaar',
			public: 'Dit evenement is openbaar',
			sign_up: 'Inschrijven via: '
		},
		register: {
			postal_code: 'Postcode',
			school: 'School',
			multiple_days: 'Mijn actie duurt meerdere dagen',
			end_hour: 'Mijn actie heeft een einduur',
			at: 'om',
			h: 'u',
			until: 'tot',
			when: 'Wanneer gaat je actie door?',
			submit: 'Voltooi je registratie',
			textarea: 'Geef een korte beschrijving van je actie',
			textarea_placeholder: 'Beschrijving',
			max100: '(Max 100 woorden)',
			organisation: 'Welke organisatie?',
			location_placeholder: 'Waar?',
			date_placeholder: 'Wanneer?',
			hour_placeholder: 'Hoe laat?'
		},
		affichebuilder: {
			with: 'Wij,',
			we_share: 'steunen met',
			at: 'in'
		},
		contact: {
			name: 'Naam',
			email: 'Email',
			question: 'Bericht',
			submit: 'Verzenden',
			thanks: 'Bedankt voor uw bericht'
		},
		filters: {
			location: 'Zoek op gemeente of postcode',
			keyword: 'Zoek op titel van de actie',
			periode: 'Zoek op datum of periode',
			periode_detail: 'Actie vindt plaats',
			and: 'en',
			filtertitle: 'Filter op soort actie',
			radius: 'Straal',
			between: 'tussen',
			on: 'op'
		},
		filterkeys: {
			food: 'Eten',
			sell: 'Verkopen',
			sports: 'Sport',
			culture: 'Cultuur',
			party: 'Feest',
			drinks: 'Drinken',
			doortodoor: 'Huis-aan-huis',
			other: 'Andere'
		},
		error404: {
			title: 'Pagina niet gevonden',
			text:
				'De pagina die je probeert te bereiken is niet beschikbaar of is onlangs verwijderd.',
			btn: 'Ga naar startpagina'
		},
		cookies: {
			text: 'Deze website gebruikt cookies om uw surfervaring te verbeteren.',
			accept: 'Cookies accepteren',
			decline: 'Cookies weigeren'
		}
	},
	ieAlert:
		'Download een moderne webbrowser om deze functionaliteit te gebruiken',
	donation: {
		supportUs: 'Steun ons',
		supportTeam: 'Steun {{teamName}}',
		info:
			'Als de som van jouw gift(en) <b>minstens 40 euro op jaarbasis</b> bedraagt, kan je <b>tot 45% van jouw gift(en)</b> recupereren via belastingvermindering. Voor een gift van 40 euro geniet je een fiscaal voordeel van 18 euro. Het kost je dus uiteindelijk slechts 22 euro.',
		infoExtra:
			'Opgelet! Indien je een <b>inzamelactie van onze vrijwilligers</b> wil steunen, bezoek dan <b>hun specifieke pagina</b> en klik daar op de groene knop ("Steun deze actie").',
		giftinfo:
			'Opgelet: Stortingen die resulteren uit een verkoop of een inzamelactie zijn niet fiscaal aftrekbaar. Deze storting is:',
		actionInfo:
			'Opgelet: Stortingen die resulteren uit een verkoop of een inzamelactie zijn niet fiscaal aftrekbaar.',
		giftOption: 'Een gift',
		actionGiftOption: 'Ik wil deze actie sponsoren, deze storting is een gift',
		yieldOption: 'Opbrengst van een verkoop of inzamelactie',
		actionYieldOption:
			'Ik ben de organisator van een inzamel- of verkoopsactie en stort hierbij de opbrengst door',
		submit: 'Ga naar betaling',
		fiscalAdvantage: 'Fiscaal voordeel',
		finalCost: 'Uiteindelijke kost',
		optin: 'Ik schrijf me in voor de nieuwsbrief van Broederlijk Delen.',
		showOnTeamPage:
			'Geeft u toestemming om uw voornaam te tonen op de actiepagina?',
		teamCanKnow: 'Geeft u toestemming om uw naam bekend te maken aan het team?',
		showOnActionPage:
			'Geeft u toestemming om uw voornaam te tonen op de actiepagina?',
		actionCanKnow:
			'Geeft u toestemming om uw naam bekend te maken aan de eigenaar van de actie?',
		privacy: 'Gaat u akkoord met de',
		privacyLink: 'algemene privacy policy',
		remainingCharacters: `Nog {{remainingCharacters}} karakters resterend.`,
		messageTo: 'Boodschap aan'
	}
}
